import styled from '@emotion/styled/macro';
import { BaseButton, forTabletLandscapeDown, Sidebar, SidebarItem, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { Collapse, CollapseProps } from '@mui/material';

export const LogoWrapper = styled.div`
    display: flex;
    height: ${Variables.topnavSize};
    padding: 20px 0 20px ${Variables.sidebarPadding};
    background-color: ${Variables.Colors.b300};

    ${forTabletLandscapeDown(`
        opacity: 0;
    `)};
`;

// FIXME:confirm z=index 2 for desktop
export const SideBar = styled(Sidebar)`
    /* margin-top: ${Variables.topnavSize}; */
    display: flex;
    flex-direction: column;
    background-color: ${Variables.Colors.sidebarBackground};
    border-right: 1px solid #DAE0E7;
`;

export const MessageCount = styled.span`
    display: inline-block;
    text-align: center;
    margin-left: 8px;
    padding: 0 4px;

    height: 18px;
    min-width: 18px;
    width: auto;
    border-radius: 18px;

    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    color: ${Variables.Colors.white};
    background-color: ${Variables.Colors.b300};
`;

export const SidebarCollapse = styled(Collapse)<CollapseProps>`
    width: 100%;
    flex-shrink: 0;
    
    /* Ensure NavLink inside collapse displays as block */
    a {
        display: block;
        width: 100%;
        text-decoration: none;
    }
`;

export const StyledSidebarItem = styled(SidebarItem)`
    color: #3E4D64 !important;
    padding-left: 8px;
    padding-right: 8px;
    margin: 8px 20px;
    width: calc(100% - 40px);
    height: 32px;
    border-radius: 12px;
    border-left: 5px solid transparent !important;
    
    &.active {
        color: #3E4D64 !important;
        background-color: #DAE0E7;
        border-left: 5px solid transparent !important;
    }
    
    &:hover {
        color: #3E4D64 !important;
        background-color: #DAE0E7;
    }
    
    &:focus,
    &:active {
        color: #3E4D64 !important;
    }
`;

export const CollapseSidebarItem = styled(SidebarItem)`
    color: #3E4D64 !important;
    padding-left: 8px;
    padding-right: 8px;
    margin: 8px 20px;
    width: calc(100% - 40px);
    height: 32px;
    border-radius: 12px;
    border-left: 5px solid transparent !important;
    
    &.active {
        color: #3E4D64 !important;
        background-color: #DAE0E7;
        border-left: 5px solid transparent !important;
    }
    
    &:hover {
        color: #3E4D64 !important;
        background-color: #DAE0E7;
    }
    
    &:focus,
    &:active {
        color: #3E4D64 !important;
    }
`;

export const RestrictedSidebarItem = styled(SidebarItem)`
    font-style: italic;
`;

export const CollapseButton = styled(BaseButton)`
    width: 24px;
    height: 24px;
    min-width: 0;
    padding: 0;
    background-color: transparent;
    margin-left: auto;
    margin-right: 12px;
`;

export const NestedCollapseButton = styled(CollapseButton)`
    margin-left: 18px;
`;

export const CollapseIcon = styled(Icon)<{ open: boolean }>`
    fill: ${Variables.Colors.sidebarIconColor};
    transition: ${Variables.transition};
    width: 32px;
    height: 32px;
`;

export const CollapseIndent = styled.span`
    display: inline-block;
    width: 18px;
`;

export const Spacer = styled.div`
    flex-grow: 1;
`;

export const DemoModeIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px ${Variables.sidebarPadding};
    margin-top: auto;
    background-color: ${Variables.Colors.amber10};
    border-top: 2px solid ${Variables.Colors.amber30};
    color: ${Variables.Colors.n70};
    font-size: 13px;
    font-weight: 500;
`;

export const DemoModeText = styled.span`
    color: ${Variables.Colors.amber30};
    font-weight: 600;
`;

export const MenuIcon = styled(Icon)`
    margin-right: 12px;
    fill: ${Variables.Colors.sidebarIconColor};
    flex-shrink: 0;
    width: 32px;
    height: 32px;
`;

export const SubMenuIcon = styled(Icon)`
    margin-right: 8px;
    fill: ${Variables.Colors.sidebarIconColor};
    flex-shrink: 0;
    width: 32px;
    height: 32px;
`;
